import autobind from 'autobind-decorator';
import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { colors, combineStyles, fonts } from '@blend/consumer-components';

interface WorkflowSelectorProps {
  workflows: WorkflowSelection[];
  selectWorkflow(requestId: string, milestoneId: string, appTemplateId: string, followUpType: string): void;
}

const styles = StyleSheet.create({
  group: {
    width: '100%',
    ':not(:last-child)': {
      marginBottom: '2.5%',
    },
  },

  button: combineStyles(fonts.Gotham, {
    cursor: 'pointer',
    border: 'solid #dadada 1px',
    padding: 20,
    backgroundColor: colors.white,
    borderRadius: 3,
    fontSize: 14,
    color: colors.clayPlus4,
    ':not(:last-child)': {
      marginRight: '2.5%',
    },
  }),
});

@autobind
class WorkflowSelector extends React.Component<WorkflowSelectorProps, {}> {
  onClickWorkflow(e) {
    const { selectWorkflow } = this.props;
    e.preventDefault();
    const { requestid, followuptype, milestoneid, apptemplateid } = e.currentTarget.dataset;
    selectWorkflow(requestid, milestoneid, apptemplateid, followuptype);
  }

  render() {
    const { workflows } = this.props;
    return (
      <div className="WorkflowSelector">
        {workflows.map((workflow, i) => {
          const validMilestoneIds = workflow.validMilestoneIds ? workflow.validMilestoneIds : ['Post-Submission'];
          const numMilestones = validMilestoneIds.length;
          // not-last-child has 2.5% right padding
          const width = (100 - (numMilestones - 1) * 2.5) / numMilestones;
          return (
            <div key={i} className={css(styles.group)}>
              {validMilestoneIds.map((milestoneId, j) => {
                return (
                  <button
                    className={css(styles.button)}
                    data-it={workflow.requestId}
                    data-requestid={workflow.requestId}
                    data-milestoneid={milestoneId}
                    data-apptemplateid={workflow.appTemplateId}
                    data-followuptype={workflow.followUpType}
                    onClick={this.onClickWorkflow}
                    key={j}
                    style={{ width: `${width}%` }}
                  >
                    {workflow.text}
                    <br />
                    {numMilestones > 1 && `(${milestoneId})`}
                    {workflow.followUpType && '(Follow-Up Only)'}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

export default WorkflowSelector;
